import React from "react"

export function Textarea({ className = "", ...props }) {
    return (
      <textarea
        className={`
          w-full rounded-md border border-gray-300 px-3 py-2
          focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary
          min-h-[80px]
          ${className}
        `}
        {...props}
      />
    )
  }
  
  